import React from "react";

class CallForsession extends React.Component {
  componentDidMount() {
    document.title = "Call For Session - CAAIE";
  }
  render() {
    return (
      <div>
        <div className="intro">
          <div className="container">
            <div className="row">
              <div className="col text-center">
                <div className="section_title_container text-center">
                  <div className="contact_title">
                    <h1> Call for Session</h1>
                  </div>
                </div>
                <div className="intro_left_content text_left">
                  <p align="left">
                    The purpose of CAAIE is to provide a platform for academics
                    and professionals in computer technology to{" "}
                    <b>
                      publish, present, meet, exchange ideas, and establish
                      professional networks.
                    </b>{" "}
                    It is a forum for specific disciplinary research, as well as
                    on multi-disciplinary studies.{" "}
                  </p>
                  <p align="left">
                    Topics for publication and presentation can include, but are
                    not limited to the following research and development
                    areas/fields:
                  </p>

                  <div align="left">
                    <div>
                      <b>Cloud Computing</b>
                    </div>
                    <ul>
                      <li>
                        <strong>AI-Enhanced Teaching and Learning</strong>
                        <ul>
                          <li>Intelligent tutoring systems</li>
                          <li>Adaptive and personalised learning</li>
                          <li>AI-driven curriculum design</li>
                        </ul>
                      </li>

                      <li>
                        <strong>
                          Learning Analytics and Educational Data Science
                        </strong>
                        <ul>
                          <li>Predictive analytics for student performance</li>
                          <li>Behavioural and engagement analytics</li>
                          <li>Ethical learning analytics in classrooms</li>
                        </ul>
                      </li>

                      <li>
                        <strong>Generative AI in Education</strong>
                        <ul>
                          <li>LLM-powered assessment and feedback</li>
                          <li>
                            AI-supported creativity and content generation
                          </li>
                          <li>Risks, bias, and academic integrity</li>
                        </ul>
                      </li>

                      <li>
                        <strong>
                          AI for Inclusive and Accessible Education
                        </strong>
                        <ul>
                          <li>Assistive technologies powered by AI</li>
                          <li>Reducing learning barriers with multimodal AI</li>
                          <li>Supporting neurodiverse learners</li>
                        </ul>
                      </li>

                      <li>
                        <strong>
                          Human–AI Collaboration in Learning Environments
                        </strong>
                        <ul>
                          <li>Teacher–AI co-teaching models</li>
                          <li>AI as a learning companion or coach</li>
                          <li>Augmenting educators, not replacing them</li>
                        </ul>
                      </li>

                      <li>
                        <strong>
                          Immersive and Experiential Learning with AI
                        </strong>
                        <ul>
                          <li>AI in VR/AR for skills training</li>
                          <li>Simulation-based learning environments</li>
                          <li>AI-generated interactive narratives</li>
                        </ul>
                      </li>

                      <li>
                        <strong>
                          Ethics, Governance, and Policy in AI Education
                        </strong>
                        <ul>
                          <li>Safe and responsible deployment of AI tools</li>
                          <li>Data protection, equity, and transparency</li>
                          <li>Accreditation and regulatory considerations</li>
                        </ul>
                      </li>

                      <li>
                        <strong>
                          AI for Lifelong, Workplace, and Professional Learning
                        </strong>
                        <ul>
                          <li>
                            Skills forecasting and personalised upskilling
                          </li>
                          <li>AI tutors for corporate learning</li>
                          <li>Intelligent micro-credentialing systems</li>
                        </ul>
                      </li>

                      <li>
                        <strong>
                          Assessment, Evaluation, and Authentic Learning in the
                          Age of AI
                        </strong>
                        <ul>
                          <li>
                            AI-supported formative and summative assessment
                          </li>
                          <li>Assessment redesign in AI-rich environments</li>
                          <li>Competency-based assessment models</li>
                        </ul>
                      </li>

                      <li>
                        <strong>
                          Advanced AI Technologies Transforming Education
                        </strong>
                        <ul>
                          <li>Multimodal AI for interactive learning</li>
                          <li>Agentic AI and autonomous learning systems</li>
                          <li>Robotics and AI in physical classrooms</li>
                        </ul>
                      </li>
                    </ul>
                  </div>

                  <div align="left">
                    <div>
                      <b>Online Learning</b>
                    </div>
                    <ul style={{ listStyleType: "circle" }} align="left">
                      <li>Digital Media Design</li>
                      <li>Online Assessment</li>
                      <li>Open Learning</li>
                      <li>Synchronous and Asynchronous Learning</li>
                      <li>Learner Engagement</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CallForsession;
